import React from "react";

const defaultStyle = {
  maxHeight: "100vh",
  maxWidth: "100vw"
};

const Preview = props => {
  const { src, style } = props;
  return <img src={src} style={style || defaultStyle} alt="preview" />;
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview/Preview.js